import React, { useEffect, useState } from 'react';
import './Body.css';
import {Card} from 'react-bootstrap';

import LineChart from './LineChart';
import StackedBarChart from './StackedBarChart';
import MultiAxisLineChart from './MultiAxisLineChart';
import CurveLineChart from './CurveLineChart';
import axios from 'axios';
import {useHistory} from 'react-router-dom';

let allcorporate=[]

function AdminDashboard(props) {

  let history=useHistory()
   let [scheme, setscheme]=useState([])
 let [call_log_user, setget_call_log_user]=useState({})
let [selected_scheme, setselected_sceme]=useState('')
// console.log('dkmksmks',props)
let [selected_scheme_name, set_selected_scheme_name] = useState('')

//let [scheme_name, setscheme_name] = useState('');

  let [graph, setgraph]=useState([])
 
  const fetscallScheme=()=>{
    axios.get('/get_schemes_stamp_paper?user_id='+props.userData.id).then((res)=>{
      allcorporate=[]
      if(Array.isArray(res.data.data)){
        res.data.data.forEach(key=>{
          if(JSON.parse(key.id)===JSON.parse(props.userData.corporate_id)){
            console.log('selected_scheme_name', key)
            
            setselected_sceme(key.id)
            set_selected_scheme_name(key.scheme_name)
          }
        })
        for(let i=0;i<props.userData.corporate.length;i++){
          res.data.data.forEach(key=>{
            if(props.userData.corporate[i].toLowerCase()===key.scheme_name.toLowerCase()){
              allcorporate.push({id:key.id, scheme_name:key.scheme_name, payment_mode:key.payment_mode})
              
            }
          })
        }
      }
      console.log('allcorporate', allcorporate)
      setscheme(res.data.data)
    })
   // const set= setscheme_name(scheme_name)
  }
 
  //  
       console.log('props.userData.roles', props.userRole)
  const get_call_log_user=()=>{
    axios.get('/get_call_log_user?user_id='+props.userData.id).then((res)=>{
      if(res.data){
        if(res.data.length!==0){
          setget_call_log_user(res.data[0])
        }
      }
    })
  }
  const getdata=(ev)=>{
    let date_from=''
    if(ev){
      date_from=new Date(ev).toDateString()
    }
    return date_from
  }
  const gettime =(ev)=>{
    let time=''
    if(ev){
       time=new Date(ev).toLocaleTimeString('en',
      { timeStyle: 'short', hour12: true });
    }
    return time;
  }
  console.log('call_log_user',allcorporate, selected_scheme) 

  const fetchGraphData=()=>{
    axios.get('/show_graph').then((res)=>{
      setgraph(res.data)
    })
  }


  useEffect(()=>{
    fetscallScheme()
    get_call_log_user()
    fetchGraphData()

  }, [])
  

  return (
    <div className='ContainerCard' style={{marginRight:0}}>
    <div className="Body">

    <div className="Text" >
     <p className='text-center' style={{marginLeft:"-13%"}} >Administration Dashboard For
              &nbsp;{selected_scheme_name}
       	</p>  
    </div>

  <div className='flex-container d-flex '  style={{height:"3%",marginBottom:"1%", flexDirection:"row",width:"100%",justifyContent:"flex-end" }}><div style={{padding:'0.8%'}}><label><span className='text-center' style={{color:"white"}} >Change Scheme</span></label></div>
  <div align="right" style={{paddingRight:"5%"}}>
    <select value={selected_scheme} onChange={(scheme_sele=>{
        console.log(scheme_sele.target.value)
        axios.get('/update_scheme?corporate_id='+scheme_sele.target.value).then(res=>{
          console.log('updated')
          history.push('/');
          //scheme_sele.preventDefault();
          window.location.reload(true);
         
        })
      })} style={{width:"16vw",fontSize:"14px",height:"38px"}}>
        <option key='-1' value="" disabled style={{height:"100%"}}>Selected Scheme</option>
        {Array.isArray(props.userData.corporate)&&
          allcorporate.map((schemeval, i)=>{
        return(
         
          <option key={i} value={schemeval.id} >{schemeval.scheme_name}</option>
         
            
              )
        }
       
        )  
        }
       
        </select>
        </div>
    </div>

    <Card className="Container2" style={{width:'100%', marginRight:0}}>
    <div className="table1">
    <div className="column1">
      <Card className="MainComponent1">
        <p className="cardtext"><b>Total requests for the month</b></p>
        <Card className="innercard1">
        <article className="graph1">
        <LineChart />
        </article>
        </Card>
        </Card>
        <Card className="MainComponent2">
          <p className="cardtext"><b>Total requests today</b></p>
          <Card className="innercard3">
          <article className="graph2">
          <MultiAxisLineChart data={graph.length!==0&&graph[2]} />
          </article>
          </Card>
        </Card>
    </div>
    <div className="column1">
    <Card className="MainComponent3">
    <p className="cardtext"><b>Total requests pending for the month</b></p>
    <Card className="innercard2">
    <article className="graph3">
    <CurveLineChart data={graph.length!==0&&graph[1]}/>
    </article>
    </Card>
    </Card>
    <Card className="MainComponent4">
    <p className="cardtext"><b>Total requests pending</b></p>
    <Card className="innercard4">
    <article className="graph4">
    <StackedBarChart data={graph.length!==0&&graph[0]}/>
    </article>
    </Card>
    </Card>
    </div>
    </div>


    </Card>
    </div>
    
    </div>

    
  );
}

export default AdminDashboard;